










export default {
  name: 'Page',
  props: {
    notFound: Boolean,
  },
}
